import React, { useEffect } from "react";
import Packky from "../assets/Packky.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <nav
      className="navbar bg-light rounded-pill mx-auto p-2 mt-3 border fixed-top"
      style={{
        width: "96vw",
        minHeight: "10vh",
        maxWidth: "1200px",
        position: "absolute",
        zIndex: 1000,
      }}
    >
      <div className="container-fluid d-flex flex-nowrap justify-content-between align-items-center">
        <div
          className="navbar-brand d-flex align-items-center justify-content-center"
          onClick={() => navigate("/")}
        >
          <img src={Packky} alt="Logo" className="img-logo" />
        </div>

        <div className="d-flex gap-2">
          <div
            onClick={() => {
              window.location.href = "/enterprise-login";
            }}
          >
            <button
              className="btn btn-custom-orange rounded-pill px-4 py-2 shadow-sm responsive-font"
              style={{ fontWeight: 100, fontSize: "20px" }}
            >
              Enterprise Login
            </button>
          </div>
          <div
            onClick={() => {
              window.location.href = "/driver-partner-login";
            }}
          >
            <button
              className="btn btn-custom-orange rounded-pill px-4 py-2 shadow-sm responsive-font"
              style={{ fontWeight: 100, fontSize: "20px" }}
            >
              Driver Partner Login
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
